































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { servicoModule } from "@/store/servico/ServicoModule";
import { clienteModule } from "@/store/cliente/ClienteModule";
import { statusList, ServicoDetalhadoModel, DadosClienteModel, FinalizarSolicitacaoModel, SolicitacaoModel} from "@/models/solicitacoes";
import { motivosList } from "@/models/solicitacoes/MotivoSolicitacaoModel";
import usuarioModule from "@/store/usuario/UsuarioModule";
import { servicoService } from "@/service/ServicoService";
import { estadosList } from "@/models/Estados";
import { ValidationObserver } from "vee-validate";
// @ts-ignore
import StringMask from "string-mask";
import { ServicoDetalhado } from "@/models/solicitacoes/ServicoDetalhado";
import { DadosCliente } from "@/models/solicitacoes/DadosCliente";
import { PrecosServicoModel } from "@/models/solicitacoes/PrecosServicoModel";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { DadosModal } from "@/components/modal/DadosModal";
import GsModal from "@/components/modal/GsModal.vue";
import { TipoModalEnum } from "@/components/modal/TipoModalEnum";
import axios from "axios";
import ImgDialog from "@/components/modal/ImgDialog.vue";
import FotoModel from "@/models/orcamento-auto-online/FotoModel";
import { tiposFotosList } from "@/models/orcamento-auto-online/TipoFoto";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
// @ts-ignore
import _ from 'lodash';
import moment from "moment";

declare var google: any;

@Component({
  components: {
    GsModalDialog,
    GsModal,
    ImgDialog
  }
})
export default class DetalheSolicitacao extends Vue {
  $refs!: {
    acceptObserver: InstanceType<typeof ValidationObserver>;
    motivoCancelamentoObserver: InstanceType<typeof ValidationObserver>;
  };

  detalheSolicitacao: ServicoDetalhadoModel = new ServicoDetalhado();
  dadosCliente: DadosClienteModel = new DadosCliente();
  precosServico: PrecosServicoModel[] = [];
  idPrestador = 0;
  idServico = 0;
  statusServico = "";

  carInfoWindow ="distancia";

  nomeMotorista = "";
  placaVeiculo = "";
  tempoEstimado = "";

   servicoAFinalizar: FinalizarSolicitacaoModel = {
    idServico: undefined,
    idPrestador: undefined
  };

  // Dialog
  showDialog = false;
  dialogType = "";
  dialogTitle = "";
  dialogMessage = "";
  loading = false;

  /* IMG MODAL */
  showImgModal = false;
  srcImg = "";
  imgType = "";
  fotos: FotoModel[] = [];

  //modal
  dadosModal: DadosModal = DadosModal.defaultValue();
  isCancelar: boolean = false;
  isFinalizar: boolean = false;
  error = false;
  errorMessage = "";
  exibirCamposGuincho = false;

  // Accept Dialog
  showAcceptDialog = false;

  cabecalho = [
    { text: "Vl. Prestador", value: "valorPrestador", sortable: false, width: "10%" },
    { text: "Vl. Pedágio", value: "valorPedagio", sortable: false ,  width: "15%"},
    { text: "Vl. Patins", value: "valorPatins", sortable: false, width: "10%"  },
    { text: "Vl. HT", value: "valorHoraTrabalhada", sortable: false, width: "10%"  },
    { text: "Vl. HP", value: "valorHoraParada", sortable: false, width: "10%"  },
    { text: "Vl. Agravo", value: "valorAgravo", sortable: false, width: "10%"  },
    { text: "Vl. Desc.", value: "valorDesconto", sortable: false, width: "10%"  },
    { text: "Vl. Perc. Gente Resolve", value: "valorOperadora", sortable: false, width: "15%"  },
    { text: "Vl. Total", value: "preco", sortable: false, width: "15%"  },
  ];

  cabecalhoPrestador = [
    { text: "Data", value: "dataHoraDistribuicao", sortable: false, width: "20%" },
    { text: "Prestador", value: "prestador", sortable: false, width: "50%" },
    { text: "Situação", value: "status", sortable: false, width: "20%"  },
    { text: "Custo do Serviço", value: "preco", sortable: false, width: "20%" },
    { text: "Ações", value: "actions", width: "5%", sortable: false }
  ];
  descricaoStatus(status: string) {
    let descricao = "";

    statusList.filter(statusStatic => {
      statusStatic.valor!!.forEach(valor => {
        if (status == valor) {
          descricao = statusStatic?.descricao || '';
        }
      });
    });
    return descricao;
  }
  descricaoPrestador(prestador: any) {
    return `${prestador.cpfCnpj} - ${prestador.nome}`;
  }

  precos: PrecosServicoModel[] =[];
  prestadores: SolicitacaoModel[] = [];

  markers = {
    "latitude": 0,
    "longitude": 0
  }; 

  origin = {};
  destination = {};
  destinationCliente = {};
  waypoints = [{}];
  pinarLocalizacao = false;
  tempoAtualizacaoPagina: number = 20000;
  _timerId: any = null;
  directionsDisplayOld: any = null;

  listaLocalRemocao = [
    { valor: "VIA_PUBLICA", descricao: "Via pública" },
    { valor: "GARAGEM_SUBSOLO", descricao: "Garagem ou subsolo" },
    { valor: "GARAGEM_NIVEL_RUA", descricao: "Garagem nível da rua " },
    { valor: "RIBANCEIRA_FORA_VIA", descricao: "Ribanceira/fora da via" },
  ]; 

  atualizarRotaAutomatica() {
    this.carregarServico(false);
    
    if (this.detalheSolicitacao.status == "EM_EXECUCAO") {
      this.directionsDisplayOld.setDirections({ routes: [] });
      this.directionsDisplayOld.setMap(null);
      this.montarPrestadoresPelaRegiao();
    }
  }
  montarPrestadoresPelaRegiao() {
    ServicosAssistenciaService.obterPrestadorPorServico(Number(this.$route.params.id)).then((res: any) => {
      let directionsService = new google.maps.DirectionsService();
      let directionsDisplay = new google.maps.DirectionsRenderer();  
      // @ts-ignore
      directionsDisplay.setMap(this.$refs.map.$mapObject);
      this.waypoints = [];
      this.pinarLocalizacao = false;
      if (res.placa != null) {
        this.origin = { lat: Number(res.latitude), lng: Number(res.longitude) };
        if (this.detalheSolicitacao.tipoServico == "GUINCHO") {
          this.waypoints =  [{ location: { lat: Number(this.detalheSolicitacao.localizacao?.latitude), lng: Number(this.detalheSolicitacao.localizacao?.longitude)}}];
        }
        this.destination = { lat: Number(this.detalheSolicitacao.destino?.latitude), lng: Number(this.detalheSolicitacao.destino?.longitude) };
      } else {
        if (this.detalheSolicitacao.tipoServico == "GUINCHO") {
          this.origin = { lat: Number(this.detalheSolicitacao.localizacao?.latitude), lng: Number(this.detalheSolicitacao.localizacao?.longitude) };
          this.destination = { lat: Number(this.detalheSolicitacao.destino?.latitude), lng: Number(this.detalheSolicitacao.destino?.longitude) };  
        } else {
          this.pinarLocalizacao = true;
        }  
      }  
      
      const request = {
        origin: this.origin,
        destination: this.destination,
        travelMode: 'DRIVING',
        waypoints: this.waypoints
      };

      directionsService.route(request, (response: any, status: any) => { 
        if (status !== "OK") return;
        this.computeTotals(response);
        directionsDisplay.setDirections(response);
        this.directionsDisplayOld = directionsDisplay;
      });
    })
    .catch((err) => {
      console.log(err);
    });
  }

  computeTotals(result: any) {
    let totalDist = result.routes[0].legs[0].distance.text;
    let totalTime = result.routes[0].legs[0].duration.text;

    this.carInfoWindow = "distancia=" + totalDist + "  |  " + totalTime;
  }

  montarPrestadoresGrid(solicitacoesPrestadores: any[]) {
    let prestadoresDistribuidos = _.filter(solicitacoesPrestadores, function(o: any) { return o.dataHoraDistribuicao != null; });
    prestadoresDistribuidos = _.orderBy(prestadoresDistribuidos, ['dataHoraDistribuicao'], ['desc']);
    this.prestadores = prestadoresDistribuidos;    
  }

  mounted() {
    this.statusServico = this.$route.params.statusServico;
    this.idServico = Number(this.$route.params.id);
    this.carregarServico(true);
    this._timerId = setInterval(this.atualizarRotaAutomatica, this.tempoAtualizacaoPagina); 
  }

  destroyed() {
    clearInterval(this._timerId);
  }

  carregarServico(primeiroLoad: boolean) {
    servicoModule.obterSolicitacaoDetalhada(this.idServico)
      .then((res: any) => {
        this.detalheSolicitacao = servicoModule.servicoDetalhado as ServicoDetalhadoModel;
        this.statusServico = this.detalheSolicitacao.statusPrestador;
        console.log(this.detalheSolicitacao);
        this.montarPrestadoresGrid(this.detalheSolicitacao.solicitacoesPrestadores);        
        if (primeiroLoad) {
          this.obterPrecosServico();
          this.obterDetalhesCliente();
          this.loadImgs(this.detalheSolicitacao.veiculo.fotos);
          this.markers.latitude = Number(this.detalheSolicitacao.localizacao?.latitude);
          this.markers.longitude = Number(this.detalheSolicitacao.localizacao?.longitude);
          this.montarPrestadoresPelaRegiao();
        } 
        
        this.exibirCamposGuincho = false;
        if (this.detalheSolicitacao.tipoServico == "GUINCHO") {
            this.exibirCamposGuincho = true;
        }   
      })
      .catch((err: any) => {
        // this.setModalErro();
      });    
  }

  obterDetalhesCliente() {
    clienteModule
      .obterDadosCliente(this.detalheSolicitacao?.idCliente!)
      .then(res => {
        this.dadosCliente = clienteModule.dadosCliente as DadosClienteModel;
      })
      .catch(err => {
        // this.setModalErro();
      })
      .finally(() => {
        // this.dadosModal.aberto = true;
      });
  }

  obterPrecosServico() {
    this.precos = [];
    ServicosAssistenciaService
    .precosServicos(Number(this.$route.params.id)).then((res: PrecosServicoModel[]) => {
          this.precos = res;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  reenviarServico = false;
  idPrestadorAceitar = 0;
  idServicoAceitar = 0;
  
  reenviarSolicitacao(servico: any) {
    this.showAcceptDialog = true;
    this.idServicoAceitar = this.detalheSolicitacao.id,    
    this.idPrestadorAceitar = servico.prestador.id;
    this.reenviarServico = true;
  }

  isReenvioSolicitacao(): boolean {
    return this.detalheSolicitacao.aceitaReenvioSolicitacao == true;
  }

  isNewSolicitation(): boolean {
    return this.detalheSolicitacao.status === 'ABERTO' && this.statusServico == "AGUARDANDO";
  }

  get localDeRemocao() {
    return this.listaLocalRemocao.find(local => local.valor == this.detalheSolicitacao.tipoLocalRemocao)?.descricao;
  }

  get associadoNoLocal() {
    return !!this.detalheSolicitacao?.associadoNoLocal;
  }
  get nomeSolicitante() {
    return this.detalheSolicitacao?.contato?.nome || "";
  }
  get nomeContato() {
    return this.detalheSolicitacao?.contato?.nome || "";
  }
  get quantidadePessoas() {
    return this.detalheSolicitacao?.transportePessoas?.quantidadePessoas || "";
  }

  get nomeSolicitanteFrota() {
    if (this.detalheSolicitacao.servicoFrota) {
      return this.detalheSolicitacao.servicoFrota.nomeSubCliente || "";
    }
    return "";  
  }

  get telefoneSolicitanteFrota() {
    if (this.detalheSolicitacao.servicoFrota) {
      return this.detalheSolicitacao.servicoFrota.telefone || "";
    }  
      return "";  
  }

  get rodaTravada() {
    return this.detalheSolicitacao.rodaTravada;
  }

  get liberadoRemocao() {
    return this.detalheSolicitacao.liberadoRemocao;
  }

  get cpfSolicitanteFrota() {
    if (this.detalheSolicitacao?.servicoFrota?.cpfCnpj) {
    const formatter = new StringMask(
          this.detalheSolicitacao?.servicoFrota?.cpfCnpj.length <= 11
          ? "000.000.000-00"
          : "00.000.000/0000-00"
      );
      return formatter.apply(
        `${this.detalheSolicitacao.servicoFrota.cpfCnpj}${this.detalheSolicitacao.servicoFrota.cpfCnpj}`
      );
    } else {
      return "";
    }  
  }

  get emailSolicitanteFrota() {
    if (this.detalheSolicitacao.servicoFrota) {
      return this.detalheSolicitacao.servicoFrota.email || "";
    } 
    return "";
  }

  get nomeLocalLocalizacao() {
    return this.detalheSolicitacao.localizacao.nomeResponsavel || "";
  }

  get telefoneLocalLocalizacao() {
    return this.detalheSolicitacao.localizacao.telefoneResponsavel || "";
  }

  get nomeLocalDestino() {
    return this.detalheSolicitacao.destino.nomeResponsavel || "";
  }

  get telefoneLocalDestino() {
    return this.detalheSolicitacao.destino.telefoneResponsavel || "";
  }

  get observacao() {
    return this.detalheSolicitacao?.transportePessoas?.observacao || "";
  }

  get possuiLimitacao() {
    if (this.detalheSolicitacao?.transportePessoas) {
      return this.detalheSolicitacao.transportePessoas.limitacao;
    } else {
      return null;
    }
  }
  get limitacao() {
    let lim = "";
    if (this.detalheSolicitacao?.transportePessoas) {
      lim += this.detalheSolicitacao.transportePessoas.acamado ? "Acamado" : "";
      lim += this.detalheSolicitacao.transportePessoas.operado ? "Operado" : "";
      lim += this.detalheSolicitacao.transportePessoas.outraLimitacao
        ? this.detalheSolicitacao.transportePessoas.outraLimitacao
        : "";
      return lim;
    } else {
      return "";
    }
  }
  get telefoneContato() {
    if (
      this.detalheSolicitacao?.contato?.dddTelefone &&
      this.detalheSolicitacao?.contato?.numeroTelefone
    ) {
      const formatter = new StringMask(
        this.detalheSolicitacao.contato.numeroTelefone.length < 9
          ? "(00) 0000-0000"
          : "(00) 00000-0000"
      );
      return formatter.apply(
        `${this.detalheSolicitacao.contato.dddTelefone}${this.detalheSolicitacao.contato.numeroTelefone}`
      );
    } else {
      return "";
    }
  }
  get placa() {
    return this.detalheSolicitacao?.veiculo.placa || "";
  }
  get marca() {
    return this.detalheSolicitacao?.veiculo.marca || "";
  }
  get modelo() {
    return this.detalheSolicitacao?.veiculo.modelo || "";
  }
  get ano() {
    return this.detalheSolicitacao?.veiculo.ano || "";
  }
  get tipo() {
    return this.detalheSolicitacao?.veiculo.tipoVeiculo || "";
  }
  get motivo() {
    return (
      motivosList.find((m: { nomeIntegracao: any; }) => {
        return m.nomeIntegracao == this.detalheSolicitacao.motivo;
      })?.descricao || ""
    );
  }
  get motivoEstorno() {
    return this.detalheSolicitacao?.motivoEstorno || "";
  }
  get valorEstorno() {
    return this.detalheSolicitacao?.valorEstornado ? this.detalheSolicitacao?.valorEstornado.toFixed(2) : `${parseFloat('0').toFixed(2)}`;
  }
  get veiculoLocalFechado() {
    if (this.detalheSolicitacao?.veiculo) {
      return this.detalheSolicitacao.veiculo.estaEmLocalFechado ? "Sim" : "Não";
    } else {
      return "";
    }
  }

  get veiculoSubsolo() {
    if (this.detalheSolicitacao?.veiculo) {
      return this.detalheSolicitacao.veiculo.estaNoSubsolo ? "Sim" : "Não";
    } else {
      return "";
    }
  }

  get existeEndereco() {
    const endereco = this.detalheSolicitacao?.localizacao?.endereco;
    if (!!!endereco) {
      return false;
    } else if (endereco && endereco.logradouro == '' && endereco.numero == '' && endereco.estado == 'PA') {
      return false;
    } else {
      return true;
    }
  } 

  get enderecoCompleto() {
    const endereco = this.detalheSolicitacao?.localizacao?.endereco;

    if (!!!endereco) {
      return '';
    } else {
      return `${endereco.logradouro}, ${endereco.numero}, ${endereco.complemento ? endereco.complemento + ', ' : ''} ${endereco.bairro}, ${endereco.cidade} - ${endereco.estado} ${endereco.referencia ? ' - Referencia: ' + endereco.referencia + '' : ''}`;
    }
  }

  get linkMapsLocalizacao() {
    const localizacao = this.detalheSolicitacao?.localizacao;

    if (!!!localizacao) {
      return '';
    } else {      
      return `https://maps.google.com/?q=${localizacao.latitude},${localizacao.longitude}`;
    }
  }

  get destinoCompleto() {
    const endereco = this.detalheSolicitacao?.destino?.endereco;
    if (!!!endereco) {
      return '';
    } else {
      return `${endereco.logradouro}, ${endereco.numero}, ${endereco.complemento ? endereco.complemento + ', ' : ''} ${endereco.bairro}, ${endereco.cidade} - ${endereco.estado}`;
    }
  }

  get nomeCliente() {
    return this.dadosCliente?.nome || "";
  }

  get emailCliente() {
    return this.dadosCliente?.email || "";
  } 
  
  get cpfCnpjCliente() {
    const formatter = new StringMask(
          this.dadosCliente?.cpfCnpj.length <= 11
          ? "000.000.000-00"
          : "00.000.000/0000-00"
      );
      return formatter.apply(
        `${this.dadosCliente?.cpfCnpj}${this.dadosCliente?.cpfCnpj}`
      );
  } 

  get telefoneCliente() {
        if (
      this.dadosCliente?.telefones[0]?.ddd &&
      this.dadosCliente?.telefones[0]?.numero
    ) {
      const formatter = new StringMask(
        this.dadosCliente.telefones[0].numero.length < 9
          ? "(00) 0000-0000"
          : "(00) 00000-0000"
      );
      return formatter.apply(
        `${this.dadosCliente.telefones[0].ddd}${this.dadosCliente.telefones[0].numero.replace('-','')}`
      );
    } else {
      return "";
    }
  }

  private openDialog(title: string, message: string, dialogType: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  voltarPagina() {
    this.$router.back();
  }

  closeDialog() {
    this.carregarServico(false);
    this.showDialog = false;
  }

  closeAcceptDialog(accept = false) {
    if (accept) {
      this.$refs.acceptObserver.validate()
        .then((valid) => {
          if (valid) {
            this.aceitar();
            this.showAcceptDialog = false;
          }
        })
    } else {
      this.showAcceptDialog = false;
    }
  }

  get btnColor() {
    return this.dialogType == 'SUCCESS' ? '#00CD96' : 'error';
  }

  get btnText() {
    return this.dialogType == 'SUCCESS' ? 'Ok, entendi' : 'Fechar';
  }

  get dialogImg() {
    return this.dialogType == 'SUCCESS' ? 'success.png' : 'error.png';
  }

  aceitar() {
    if (this.detalheSolicitacao) {

      if (this.reenviarServico) {
        servicoService.reenviarSolicitacao(
          this.idServicoAceitar,
          this.idPrestadorAceitar,
          this.nomeMotorista,
          this.placaVeiculo,
          this.tempoEstimado
        )
        .then(res => {
          this.openDialog(
            'Sucesso',
            'Serviço reenviado e aceito com sucesso.',
            'SUCCESS'
          );
        })
        .catch(err => {
          this.openDialog(
            'Erro',
            'Ocorreu um erro ao efetuar o reenvio do serviço.',
            'ERROR'
          );
        });
      } else {
        let prestadorAtual = _.find(this.detalheSolicitacao.solicitacoesPrestadores, function(o: any) { return o.status == 'AGUARDANDO'; });
        if (prestadorAtual == undefined) {
          this.openDialog(
            'Erro',
            'Não existe prestador em status para atendimento, recarregue a pagina',
            'ERROR'
          );
          return;
        }                
        servicoService.aceitarSolicitacao(
          this.detalheSolicitacao.id,
          prestadorAtual.prestador.id,
          this.nomeMotorista,
          this.placaVeiculo,
          this.tempoEstimado
        )
        .then(res => {
          this.openDialog(
            'Sucesso',
            'Serviço aceito com sucesso.',
            'SUCCESS'
          );
        })
        .catch(err => {
          this.openDialog(
            'Erro',
            'Ocorreu um erro ao efetuar o aceite do serviço.',
            'ERROR'
          );
        });
      }
    }
  }

  exibirFinalizarServico() {
    return (
      this.statusServico == "ACEITO" &&
      this.detalheSolicitacao.status != "PENDENTE_APROVACAO" &&
      this.detalheSolicitacao.status != "FINALIZADO" &&
      this.detalheSolicitacao.status != "AGUARDANDO"
    );
  }

  recusar() {
    if (this.detalheSolicitacao) {
      let prestadorAtual = _.find(this.detalheSolicitacao.solicitacoesPrestadores, function(o: any) { return o.status == 'AGUARDANDO'; });
      if (prestadorAtual == undefined) {
        this.openDialog(
          'Erro',
          'Não existe prestador em status para rejeição, recarregue a pagina',
          'ERROR'
        );
        return;
      }
      
      servicoService.recusarSolicitacao(
        this.detalheSolicitacao.id,
        prestadorAtual.prestador.id
      )
      .then(res => {
        this.openDialog(
          'Sucesso',
          'Serviço recusado com sucesso.',
          'SUCCESS'
        );
      })
      .catch(err => {
        this.openDialog(
          'Erro',
          'Ocorreu um erro ao efetuar a recusa do serviço.',
          'ERROR'
        );
      });
    }
  }

  fecharModal() {
    const tipo = this.dadosModal.titulo;
    this.dadosModal = DadosModal.defaultValue();
    this.servicoAFinalizar = {};

    this.carregarServico(false);
  }

  cancelar() {
    this.dadosModal.aberto = false;
    this.isCancelar = false;
    this.isFinalizar = false;
  }

  solicitarFinalizarServico() {
    this.fecharModal();

    let solicitacao = this.detalheSolicitacao as any;
    this.servicoAFinalizar = {
      idServico: this.detalheSolicitacao.id,
      idPrestador: solicitacao.prestador.id
    };

    this.isFinalizar = true;
    this.dadosModal.fullscreen = false;
    this.dadosModal.titulo = "Finalizar da Solicitação";

    this.dadosModal.tipo = TipoModalEnum.PADRAO;
    this.dadosModal.aberto = true;
    this.dadosModal.largura = "700";
  }

   finalizarServico() {
    if (this.servicoAFinalizar) {
      this.alterarStatusAtendidoComSucesso();

      servicoService
        .finalizarServico(this.servicoAFinalizar)
        .then(res => {
          this.fecharModal();
          this.dadosModal.fullscreen = false;
          this.dadosModal.titulo = "Sucesso";
          if (this.isFinalizar) {
            this.dadosModal.mensagem = `Serviço finalizado com sucesso.`;
          } else {
            this.dadosModal.mensagem = `Esse processo invalidará qualquer cobrança referente a esse atendimento.
            Estaremos encaminhando à Central para que acione outro Prestador de Serviço para esse atendimento.`;
          }
          this.dadosModal.largura = "600";
          this.dadosModal.aberto = true;
          this.isFinalizar = false;
          this.isCancelar = false;

          this.dadosModal.tipo = TipoModalEnum.PADRAO;
        })
        .catch(err => {
          this.fecharModal();
          this.isFinalizar = false;
          this.isCancelar = false;
          this.dadosModal.fullscreen = false;
          this.dadosModal.titulo = "Erro";
          if (this.isFinalizar) {
            this.dadosModal.mensagem =
              "Ocorreu um erro ao efetuar a finalização do serviço";
          } else {
            this.dadosModal.mensagem =
              "Ocorreu um erro ao efetuar cancelar o serviço";
          }
          this.dadosModal.aberto = true;
          this.dadosModal.tipo = TipoModalEnum.ERRO;
        });
    }
  }

  alterarStatusAtendidoComSucesso() {
    if (this.isFinalizar) {
      this.servicoAFinalizar.atendidoComSucesso = true;
    } else {
      this.servicoAFinalizar.atendidoComSucesso = false;
    }
  }

  solicitarCancelarServico() {
    this.fecharModal();    

    let solicitacao = this.detalheSolicitacao as any;
    this.servicoAFinalizar = {
      idServico: this.detalheSolicitacao.id,
      idPrestador: solicitacao.prestador.id
    };
    
    this.isCancelar = true;    
    this.dadosModal.fullscreen = false;
    this.dadosModal.titulo = "Cancelar Solicitação";

    this.dadosModal.tipo = TipoModalEnum.PADRAO;
    this.dadosModal.aberto = true;
    this.dadosModal.largura = "600";
  }

  cancelarServico() {
    this.$refs.motivoCancelamentoObserver.validate().then(valid => {
      if (valid) {
        this.alterarStatusAtendidoComSucesso();
        this.finalizarServico();
      }
    });
  }

  private loadImgs(imgs: FotoModel[]): void {
    const total = (imgs.length - 1);
    const convertedImgs: FotoModel[] = [];

    imgs.forEach((file: FotoModel, i: number) => {
      const data: FotoModel = {
        tipo: file.tipo ?? '',
        nomeArquivo: file.nomeArquivo ?? '',
        tipoFoto: tiposFotosList.find(t => t.name == file.tipo)
      };
      this.loadImgBase64(data.nomeArquivo ?? '').then((base64) => {
        data.base64 = base64;
        convertedImgs.push(data);
        if (i == total) {
          this.fotos = convertedImgs;
        }
      });
    });
  }

  private loadImgBase64(imgName: string): Promise<string> {
    return servicoService.obterFotoPorIdServicoENomeArquivo(this.detalheSolicitacao?.id, imgName)
      .then((resp) => {
        var reader = new FileReader();
        reader.readAsDataURL(resp);
        return new Promise(resolve => {
          reader.onloadend = function() {
            resolve(reader.result as string);
          }
        });
      })
  }

  openImgModal(imgName: string, imgType: string) {
    servicoService.obterFotoPorIdServicoENomeArquivo(this.detalheSolicitacao?.id, imgName)
      .then((resp) => {
        var reader = new FileReader();
        reader.readAsDataURL(resp);
        new Promise(resolve => {
          reader.onloadend = function() {
            resolve(reader.result);
          }
        }).then(res => {
          this.srcImg = res as string;
          this.imgType = imgType;
          this.showImgModal = true;
        });
      })
  }

  closeImgModal(): void {
    this.showImgModal = false;
  }

  downloadImg() {
    axios({
      url: this.srcImg,
      method: 'GET',
      responseType: 'blob'
    })
    .then((resp) => {
      var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
      var fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', `${this.imgType}.jpg`);
      document.body.appendChild(fileLink);

      fileLink.click();
    });
  }

}
